import React, { useState, useEffect } from 'react';
import ColorPicker from './ColorPicker';
import './ColorEditor.css';

// finds gradient
const findGradient = (str) => {
    if (str.includes('linear-gradient') || str.includes('radial-gradient')) {
        return true;
    } else return false;
};
// array of found hex colors
const findHex = (str) => {
    const hex = str.match((/#[0-9a-f]{3,6}/gi));
    return hex;
};
// finds degrees rotation
const findDeg = (str) => {
    const deg = str.split('deg');
    if (deg[0].includes('linear-gradient')) {
        return parseInt(deg[0].split('linear-gradient(')[1]);
    };
};
// finds gradient type
const findGradientType = (str) => {
    if (str.includes('linear-gradient')) {
        return 'linear';
    } else if (str.includes('radial-gradient')) {
        return 'radial';
    } else return 'linear';
};

export default function ColorEditor(props) {

    const { styles, showColorEditor, setShowColorEditor, themeEdit, setThemeEdit } = props;

    // stores starting color/gradient
    const [resetColor] = useState(themeEdit[showColorEditor]);

    const [ title, setTitle ] = useState('');
    const [ showColorPicker, setShowColorPicker ] = useState('');
    const [ color1, setColor1 ] = useState((findGradient(themeEdit[showColorEditor]) && (findHex(themeEdit[showColorEditor]).length === 2 || findHex(themeEdit[showColorEditor]).length === 3)) ? findHex(themeEdit[showColorEditor])[0] : themeEdit[showColorEditor]);
    const [ color2, setColor2 ] = useState((findGradient(themeEdit[showColorEditor]) && (findHex(themeEdit[showColorEditor]).length === 2 || findHex(themeEdit[showColorEditor]).length === 3)) ? findHex(themeEdit[showColorEditor])[1] : '');
    const [ color3, setColor3 ] = useState((findGradient(themeEdit[showColorEditor]) && findHex(themeEdit[showColorEditor]).length === 3) ? findHex(themeEdit[showColorEditor])[2] : '');
    const [ preview, setPreview ] = useState('');
    const [ rotation, setRotation ] = useState(themeEdit[showColorEditor].includes('linear-gradient') ? findDeg(themeEdit[showColorEditor]) : 0);
    const [ gradientType, setGradientType ] = useState(findGradientType(themeEdit[showColorEditor]));

    useEffect(() => {
        if (showColorEditor === 'main_background') {
            setTitle('Main Background');
        } else if (showColorEditor === 'card_background') {
            setTitle('Card Background');
        } else if (showColorEditor === 'icon_color') {
            setTitle('Icon Color');
        } else if (showColorEditor === 'btn_color') {
            setTitle('Button Color');
        } else if (showColorEditor === 'profile_img_border') {
            setTitle('Profile Image Border');
        } else if (showColorEditor === 'top_text_color') {
            setTitle('Top Text Color');
        } else if (showColorEditor === 'btm_text_color') {
            setTitle('Bottom Text Color');
        };
    }, [showColorEditor])

    const handleClose = () => {setShowColorPicker('');};

    const handleColorChange = (e, name) => {
        if (name === 'color1') {
            setColor1(e);
        } else if (name === 'color2') {
            setColor2(e);
        } else if (name === 'color3') {
            setColor3(e);
        };
    };

    const handleAddColor = () => {
        if (color1 && !color2) {
            setColor2('#000000');
        } else if (color1 && color2 && !color3) {
            setColor3('#000000');
        };
    };

    const handleSubtractColor = () => {
        if (color1 && color2 && color3) {
            setColor3('');
        } else if (color1 && color2 && !color3) {
            setColor2('');
        };
    };

    const handleColorReset = () => {
        setThemeEdit(prev => ({...prev, [showColorEditor]: resetColor}));
        setColor1((findGradient(resetColor) && (findHex(resetColor).length === 2 || findHex(resetColor).length === 3)) ? findHex(resetColor)[0] : resetColor);
        setColor2((findGradient(resetColor) && (findHex(resetColor).length === 2 || findHex(resetColor).length === 3)) ? findHex(resetColor)[1] : '');
        setColor3((findGradient(resetColor) && findHex(resetColor).length === 3) ? findHex(resetColor)[2] : '');
        setRotation(resetColor.includes('linear-gradient') ? findDeg(resetColor) : 0);
        setGradientType(findGradientType(resetColor));
    };

    useEffect(() => {
        if (gradientType === 'linear') {
            if (color1 && !color2) {
                setPreview(color1);
            } else if (color1 && color2 && !color3) {
                setPreview(`linear-gradient(${rotation}deg, ${color1}, ${color2})`);
            } else if (color1 && color2 && color3) {
                setPreview(`linear-gradient(${rotation}deg, ${color1}, ${color2}, ${color3})`);
            };
        } else if (gradientType === 'radial') {
            if (color1 && !color2) {
                setPreview(color1);
            } else if (color1 && color2 && !color3) {
                setPreview(`radial-gradient(${color1}, ${color2})`);
            } else if (color1 && color2 && color3) {
                setPreview(`radial-gradient(${color1}, ${color2}, ${color3})`);
            };
        }
    },[color1, color2, color3, rotation, gradientType])

    useEffect(() => {
        if (preview) {
            setThemeEdit(prev => ({
                ...prev,
                [showColorEditor]: preview
            }));
        };
    }, [preview, showColorEditor])

    return (
        <div className='color-editor-container'>
            <div className='color-editor-top'>
                <div className='color-editor-back' onClick={() => setShowColorEditor('')}><i className="far fa-arrow-left me-1" />Back</div>
                <div className='color-editor-title'>{title}</div>
                <div className='color-editor-reset' onClick={handleColorReset}>Reset</div>
            </div>
            <div className='color-editor-description mt-1'>Select a color or add more to create a gradient!</div>
            <div className='color-editor-swatch-container'>
                {color1 ?
                    <>
                    <div className='color-editor-swatch' onClick={() => setShowColorPicker('color1')}>
                        <div className='color-editor-swatch-inner' style={{backgroundColor: color1}} />
                    </div>
                    {showColorPicker === 'color1' ? 
                        <div style={ styles.popover }>
                            <div style={ styles.cover } onClick={handleClose} />
                            <ColorPicker
                                name='color1'
                                color={color1}
                                onChange={handleColorChange}
                            />
                        </div> : null 
                    }
                    </>
                    : null
                }
                {color2 ?
                    <>
                    <div className='color-editor-swatch' onClick={() => setShowColorPicker('color2')}>
                        <div className='color-editor-swatch-inner' style={{backgroundColor: color2}} />
                    </div>
                    {showColorPicker === 'color2' ? 
                        <div style={ styles.popover }>
                            <div style={ styles.cover } onClick={handleClose} />
                            <ColorPicker
                                name='color2'
                                color={color2}
                                onChange={handleColorChange}
                            />
                        </div> : null 
                    }
                    </>
                    : null
                }
                {color3 ?
                    <>
                    <div className='color-editor-swatch' onClick={() => setShowColorPicker('color3')}>
                        <div className='color-editor-swatch-inner' style={{backgroundColor: color3}} />
                    </div>
                    {showColorPicker === 'color3' ? 
                        <div style={ styles.popover }>
                            <div style={ styles.cover } onClick={handleClose} />
                            <ColorPicker
                                name='color3'
                                color={color3}
                                onChange={handleColorChange}
                            />
                        </div> : null 
                    }
                    </>
                    : null
                }
            </div>
            <div className='color-editor-add-subtract-container'>
                {color2 || color3 ?
                    <div className='color-editor-subtract-color' onClick={handleSubtractColor}><i className='far fa-minus' /></div>
                    : null
                }
                {!color2 || !color3 ?
                    <div className='color-editor-add-color' onClick={handleAddColor}><i className='far fa-plus' /></div>
                    : null
                }
            </div>
            <div className='color-editor-gradient-type-container'>
                <div className='color-editor-gradient-type-title'>Gradient Type</div>
                <fieldset>
                    <label htmlFor='linear' className='color-editor-gradient-type-inner'>
                        <input type='radio' id='linear' value='linear' checked={gradientType === 'linear'} onChange={(e) => setGradientType(e.target.value)} />
                        <div className='color-editor-custom-radio'><span className='color-editor-custom-radio-inner' /></div>
                        Linear
                    </label>
                    <label htmlFor='radial' className='color-editor-gradient-type-inner'>
                        <input type='radio' id='radial' value='radial' checked={gradientType === 'radial'} onChange={(e) => setGradientType(e.target.value)} />
                        <div className='color-editor-custom-radio'><span className='color-editor-custom-radio-inner' /></div>
                        Radial
                    </label>
                </fieldset>
            </div>
            {gradientType === 'linear' ?
                <div className='color-editor-rotation-container'>
                    <label htmlFor='rotation' className='color-editor-rotation-title'>Gradient Direction</label>
                    <div className='color-editor-rotation-inner'>
                        <input type='range' id='rotation' className='color-editor-rotation-slider' min='0' max='360' step='5' value={rotation} onChange={(e) => setRotation(e.target.value)} disabled={!color2} />
                        <input type='number' className='color-editor-rotation-increment' min='0' max='360' step='5' value={rotation} onChange={(e) => setRotation(e.target.value)} disabled={!color2} />
                    </div>
                </div> :
                null
            }
            <div className='color-editor-preview-container'>
                <div className='color-editor-preview-title'>Preview</div>
                <div className='color-editor-preview'><div className='color-editor-preview-inner' style={{background: preview}} /></div>
            </div>
        </div>
    );
};